import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-content-builder-common/brand-kit";
import { getInputStyles } from "@redotech/redo-content-builder-common/brand-kit/utils";
import { InputStyleOverride } from "@redotech/redo-content-builder-common/element-schema";
import classNames from "classnames";
import {
  RedoPhoneNumberInput,
  RedoPhoneNumberInputProps,
} from "./arbiter-components/input/redo-phone-number-input";
import {
  RedoTextInput,
  RedoTextInputProps,
} from "./arbiter-components/input/redo-text-input";
import {
  RedoTextareaInputField,
  RedoTextareaInputFieldProps,
} from "./arbiter-components/input/redo-textarea-input-field";
import * as css from "./brand-kit-text-input.module.css";

/* Memoizing this causes the signup form builder to not update the override styles */
export const BrandKitTextInput = function BrandKitTextInput({
  brandKit,
  override,
  elementOverride,
  htmlPattern,
  ...props
}: Omit<RedoTextInputProps, "style"> & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
  elementOverride?: InputStyleOverride | null;
  htmlPattern?: string;
}) {
  const style = getInputStyles(brandKit, override, elementOverride);
  return (
    <RedoTextInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      htmlPattern={htmlPattern}
      {...props}
    />
  );
};

export const BrandKitPhoneNumberInput = function BrandKitPhoneNumberInput({
  brandKit,
  override,
  elementOverride,
  htmlPattern,
  supportedCountryCodes,
  ...props
}: RedoPhoneNumberInputProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
  elementOverride?: InputStyleOverride | null;
}) {
  const style = getInputStyles(brandKit, override, elementOverride);

  return (
    <RedoPhoneNumberInput
      className={classNames(
        css.brandKitTextInput,
        css.brandKitPhoneNumberInput,
      )}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      htmlPattern={htmlPattern}
      supportedCountryCodes={supportedCountryCodes}
      {...props}
    />
  );
};

export const BrandKitTextAreaInput = function BrandKitTextAreaInput({
  brandKit,
  override,
  elementOverride,
  ...props
}: RedoTextareaInputFieldProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
  elementOverride?: InputStyleOverride | null;
}) {
  const style = getInputStyles(brandKit, override, elementOverride);

  return (
    <RedoTextareaInputField
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
